import http from "../utils/axios";
import config from "../config";
import jsonJoin from "../utils/jsonJoin";
import { getStorage } from "../utils/storage";

// 获取套餐信息
const getPackageListApi = () => {
  return http.get(
    `${config.qnwProjectDomain}/api/price_plan?soft_id=${config.soft_id}`
  );
};

// 获取用户 tokens 剩余多少
const getUserTokensApi = () => {
  return http.get(
    `${config.qnwProjectDomain}/api/user/productTokens?token=${getStorage(
      "token"
    )}`
  );
};
// 获取token套餐信息
const getTokenPlanApi = () => {
  return http.get(
    `${config.qnwProjectDomain}/api/token_plan?soft_id=${config.soft_id}`
  );
};
// 获取积分套餐信息
const getPointPlanApi = () => {
  return http.get(
    `${config.qnwProjectDomain}/api/point_plan?soft_id=${config.soft_id}`
  );
};
// 获取订阅套餐信息
const getSubscribePackageListApi = () => {
  return http.get(`${config.qnwProjectDomain}/api/order-subscribe`);
};
// 取消订阅套餐
const getDelSubscribePackageListApi = (delId) => {
  return http.delete(`${config.qnwProjectDomain}/api/order-subscribe/${delId}`);
};

const getPayCodeApi = (plan_type, goods_id, code) => {
  const params = {
    curr_ver: config.curr_ver,
    soft_id: config.soft_id,
    mac_code: config.mac_code,
    device_code: config.device_code,
    os: config.os,
    source: config.source,
    mp: config.mp,
    bdVid: config.bdVid,
    qhclickid: config.qhclickid,
    strategy: config.strategy,
    device_id: config.device_id,
    ekey: config.ekey,
    plan_type: plan_type,
    goods_id: goods_id,
    coupon_code: code,
    uncache: 1,
  };
  return http.get(
    `${config.wxLoginAndPayDomain}/api/wechat-qr?${jsonJoin(params)}`
  );
};

const getPayCodeUrlApi = (plan_type, goods_id, code) => {
  const data = {
    curr_ver: config.curr_ver,
    soft_id: config.soft_id,
    mac_code: config.mac_code,
    device_code: config.device_code,
    os: config.os,
    source: config.source,
    mp: config.mp,
    bdVid: config.bdVid,
    qhclickid: config.qhclickid,
    strategy: config.strategy,
    device_id: config.device_id,
    ekey: config.ekey,
    plan_type: plan_type,
    goods_id: goods_id,
    redirect_url: window.location.href,
    coupon_code: code,
  };
  const params = {
    soft_id: config.soft_id,
    ekey: config.ekey,
    source: config.source,
  };
  return http.post(
    `${config.wxLoginAndPayDomain}/api/order?${jsonJoin(params)}`,
    data
  );
};

const confirmPayInfoApi = (order_id) => {
  return http.get(
    `${config.wxLoginAndPayDomain}/api/verify-buy?order_id=${order_id}`
  );
};

export {
  getPackageListApi,
  getPayCodeApi,
  getPayCodeUrlApi,
  confirmPayInfoApi,
  getTokenPlanApi,
  getPointPlanApi,
  getUserTokensApi,
  getSubscribePackageListApi,
  getDelSubscribePackageListApi,
};
